import styled from 'styled-components';

export const Footer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`;

export const Row = styled.div`
    display: flex;
    gap: 10px;
`;

export const Column = styled.div`
`;